import { useCallback, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { BridgeService } from '@services/bridge'
import Tag from '@utils/Tag'
import { ApplicationState } from '@store/types'
import { getProductByConvenio, openLinkByEnviroment } from '@utils/functions'

export const SOU_GOV_URL = 'https://www.gov.br/sougov'

type SiapeAuthorizationAttempt = 'first' | 'second'

const ATTEMPT_CONFIG = {
  first: {
    tacName: 'siape_autorizacao_primeira_tentativa',
    ticAction: 'siape_primeira_tentativa',
  },
  second: {
    tacName: 'siape_autorizacao_segunda_tentativa',
    ticAction: 'siape_segunda_tentativa',
  },
} as const

const TAG_BASE = {
  ref_figma: '3',
  name: 'NOVO_SIAPE_FLUXO',
  screen: 'Autorizacao de margem',
  ref_type: 'Botao',
  content_action: 'Toque',
} as const

const sendButtonTagging = (
  isApp: boolean,
  product: string,
  actionId: string,
  redirectUrl: string,
) => {
  if (isApp) {
    Tag.enviarTagueamentoApp({
      ...TAG_BASE,
      action_id: actionId,
      product,
    })
    return
  }

  Tag.enviarTagueamentoWeb({
    element_name: actionId,
    section_name: 'Autorizacao de margem',
    element_action: 'click button',
    c_page: window.location.href,
    redirect_url: redirectUrl,
    step: 'null',
  })
}

interface UseSiapeAuthorizationSheetParams {
  attempt: SiapeAuthorizationAttempt
  onConfirmAuthorization: () => void
  onRetryMarginResult: () => void
}

export const useSiapeAuthorizationSheet = ({
  attempt,
  onConfirmAuthorization,
  onRetryMarginResult,
}: UseSiapeAuthorizationSheetParams) => {
  const isApp = useSelector((state: ApplicationState) => state.ui.navigation.isApp)
  const convenioCodigo = useSelector(
    (state: ApplicationState) => state.refinanciamento.contratos.convenioCodigo,
  )
  const product = getProductByConvenio(convenioCodigo)
  const { tacName, ticAction } = ATTEMPT_CONFIG[attempt]

  useEffect(() => {
    BridgeService.tac({
      name: tacName,
      actions: ['carregamento_dados'],
    })
  }, [tacName])

  const handleAccessSouGov = useCallback(async () => {
    BridgeService.tic({
      name: 'btn_acessar_sougov',
      action: ticAction,
    })

    sendButtonTagging(isApp, product, 'Acessar SouGov', SOU_GOV_URL)
    await openLinkByEnviroment(SOU_GOV_URL, true)
  }, [isApp, product, ticAction])

  const handleConfirmAuthorization = useCallback(() => {
    BridgeService.tic({
      name: 'btn_ja_autorizei',
      action: ticAction,
    })

    sendButtonTagging(isApp, product, 'Já autorizei', window.location.href)
    onConfirmAuthorization()
    onRetryMarginResult()
  }, [isApp, onConfirmAuthorization, onRetryMarginResult, product, ticAction])

  return { handleAccessSouGov, handleConfirmAuthorization }
}
